export const regexPIva = /^(IT)?(It)?(iT)?(it)?[0-9]{11}$/
export const regexNoSpecialCharacters = /^[0-9a-zA-Z]+$/
export const regexPhoneNumbers = /^(\+)?[0-9.\-/ ]+$/
export const isAlphanumeric = /^\+?([0-9 ]+)$$/
